/**
 * LogosOS UI System: ThinkingConfig v1.1
 *
 * Public exports for OS-level thinking animation contract
 */

export type {
  ThinkingConfig,
  ThinkingRuntime,
  ThinkingEnv,
  ThinkingConfigVersion,
  ThinkingBreathMode,
  ThinkingVisualEmphasis,
  ThinkingMotionComplexity,
  ThinkingContext,
  ThinkingDebug,
} from "./types"

export { resolveThinkingRuntime } from "./resolver"
export { getDefaultThinkingConfig, getRecommendedSemantics } from "./defaults"
